import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TodoService } from '../todo.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LocalUserService } from 'app/main/shared/services/localUser';
import * as moment from 'moment';
import { MatSidenav, MatDialog } from '@angular/material';
import { EguardConfirmatialogComponent } from 'app/core/components/confirm-dialog/confirm-dialog.component';
import { ShareListComponent } from '../components/share-list/share-list.component';
import { OrganizationServices } from 'app/main/shared/services/organization.services';

@Component({
  selector: 'todo-list',
  templateUrl: './todo-list.component.html',
  styleUrls: ['./todo-list.component.scss']
})
export class TodoListComponent implements OnInit {


  @Input()
  preference: any;
  @Input()
  projects: any;

  @Input() project: any;

  @Output()
  update: EventEmitter<any> = new EventEmitter();
  @Output()
  remove: EventEmitter<any> = new EventEmitter();

  selectedTask: any;

  isLoading = false;
  showIcon = false;
  progress = true;
  userId: string;
  listId: string;
  // projects = [];
  prioritydata = null;
  taskname = null;
  filteredProjects = [];
  day;
  data: any;
  projectName: string;
  id: string;

  task: string;
  priority: string;
  date: Date;
  note: any;
  myday: Date;
  selectedId: string;
  selectedName: string;
  tasks: any[] = [];
  setPriority: string;
  sortedData = [];

  projectData: {
    title: string,
    note: string,
    due_date: Date,
    priority: string,
    my_day: Date,
  };

  sharedNames: {
    id: string,
    name: string
  }[] = [];
  orgUsers: any[] = [];

  left: any;
  currentDate: Date;

  @ViewChild('left') public sidenav: MatSidenav;
  dialogRef: any;
  orgId: string;
  constructor(
    private todoService: TodoService,
    private activatedRoute: ActivatedRoute,
    private localStore: LocalUserService,
    private router: Router,
    public dialog: MatDialog,
    private organizationServices: OrganizationServices,
  ) {
    this.userId = localStore.getUserId();

  }

  ngOnInit() {

  }
  getAllUsers(orgID: string) {
    this.progress = true;
    this.organizationServices.getUsersInOrganization(orgID)
      .subscribe(page => {
        this.orgUsers = page || [];
        this.setSharedUsersNames();
        this.progress = false;
      });
  }

  setSharedUsersNames() {
    this.progress = true;
    if (!this.project.shared_with || !this.orgUsers && !this.orgUsers.length) return;
    this.sharedNames = [];
    this.project.shared_with.forEach((userId) => {
      let user = this.orgUsers.find(user => user.id == userId)
      if (user) {
        let item = {
          id: user.id,
          name: user.first_name + user.last_name
        }
        this.sharedNames.push(item);
      }
    })
    this.progress = false;
  }

  shareDialog(): void {
    let dialogRef = this.dialog.open(ShareListComponent, {
      panelClass: 'userList',
      width: '450px',
      maxHeight: 'auto',
      data: {
        project: this.project
      }
    });

    const instance = dialogRef.componentInstance


    instance.refresh.subscribe((val) => {

    })

    dialogRef.afterClosed().subscribe(result => {
      this.update.emit();
      console.log('The dialog was closed');
    });
  }
  ngOnChanges() {
    if (this.project) {
      this.defaultSort();
      this.sidenav.close();
    }
    if (this.preference && this.preference.hide_completed_subtask_on) {
      this.project.hideCompleteTask = true
    }
    // this.orgId = this.localStore.getOrganizationId();
    // this.getAllUsers(this.orgId)
  }

  setCreatedDateTask() {
    if (this.preference.sort_by_creation_date_on) {
      this.defaultSort();
    }
    this.sortedData = this.project.tasks
  }

  defaultSort() {
    this.sortedData = []
    this.sortedData = this.project.tasks.slice();
    let data = this.sortedData
    this.sortedData = data.sort((a, b) => {
      const isAsc = true;
      return compare(+a.created_date, +b.created_date, isAsc);
    })

    if (this.selectedTask) {
      this.selectedTask = this.sortedData.find(item => item.id === this.selectedTask.id)
    }
  }

  addNewTask(newData) {
    let taskDetail;
    this.progress = true;
    taskDetail = newData;
    this.projectData = {
      title: this.task,
      note: this.note,
      due_date: this.date,
      my_day: this.myday,
      priority: this.priority
    };
    this.todoService.addTask(this.userId, this.project.id, this.projectData).subscribe(
      data => {
        this.project.tasks.push(data);
        this.setCreatedDateTask();
        this.progress = false;
        // this.project.tasks = null;
        this.task = null;
        this.update.emit();
      },
      err => {
        console.log(err);
        this.progress = false;
      }
    );
  }

  priorityData(event) {
    this.prioritydata = event;
    if (event != null) {
      if (event.value !== 'ALL') {
        this.filteredProjects = this.projects.filter(data => {
          return data.priority === event.value;
        });
      } else {
        this.filteredProjects = this.projects;
      }
    } else {
      this.filteredProjects = this.projects;
    }
  }
  toTitleCase(str) {
    if (!str) return;
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }
  getTask() {
    this.progress = true;
    this.activatedRoute.params.subscribe((params: Params) => {
      this.projectName = this.toTitleCase(params['projectname']);

      if (this.data !== {}) {
        this.todoService.getTask(this.userId, this.project.id).subscribe(data => {
          this.projects = data;
          this.priorityData(null);
          this.progress = false;
        });
      } else {
        this.data = this.activatedRoute.snapshot.data;
        this.projects = this.data.todoResolve;
        this.priorityData(null);
        this.progress = false;
      }
    });
  }


  deleteTask(event) {
    this.progress = true;
    this.todoService
      .deleteTask(this.userId, event.list_id, event.id)
      .subscribe(data => {
        this.project.tasks = this.project.tasks.filter(task => task.id !== event.id);
        this.priorityData(this.prioritydata);
        this.update.emit();
        this.progress = false;
      });
  }


  updateTask(task) {
    this.progress = true;
    this.todoService
      .updateTask(this.userId, task.list_id, task.id, task)
      .subscribe(data => {
        this.update.emit();
        this.progress = false;
      });

    event.stopPropagation();
  }

  upDateList($event) {
    this.update.emit()
  }

  stepsComplete(task) {
    return task.steps.filter(step => step.is_completed).length
  }
  updateProject(updateProject: any) {
    this.progress = true;
    let projectData = {};
    projectData['name'] = updateProject.name;
    projectData['sort_order'] = '1';

    this.todoService
      .updateProject(this.userId, updateProject.id, projectData)
      .subscribe(data => {
        this.selectedId = null;

        this.update.emit();
        this.selectedName = null;
        this.progress = false;
      });
  }
  delete(projectData) {
    this.progress = true;
    this.todoService
      .deleteProject(this.userId, projectData.id)
      .subscribe(data => {
        this.remove.emit();
        this.progress = false;
      });
  }
  getTaskCopy(task, project) {
    this.progress = true;
    this.todoService.copyTask(this.userId, task.list_id, task.id, project.id)
      .subscribe(task => {
        this.update.emit();
        this.progress = false;
      })
  }
  getTaskMove(task, project) {
    this.progress = true;
    this.todoService.moveTask(this.userId, task.list_id, task.id, project.id)
      .subscribe(task => {
        this.update.emit();
        this.progress = false;
      })
  }
  createNewList(task) {
    this.progress = true;
    let model = {
      task_id: task.id,
      list_id: task.list_id
    }
    this.todoService.createNewList(this.userId, model)
      .subscribe(list => {
        this.update.emit();
        this.progress = false;
      })
  }

  getNextPriority(value) {
    if (value == 'LOW') {
      return 'MEDIUM'
    } else if (value == 'MEDIUM') {
      return 'HIGH'
    } else if (value = 'HIGH') {
      return 'LOW'
    }
  }

  changePriority(task) {
    task.priority = this.getNextPriority(task.priority)

    this.updateTask(task)
  }



  addMyDay(task) {
    task.my_day = new Date();
    this.updateTask(task)
  }

  addDueDate(time: string, task) {
    task.due_date = new Date()
    if (time !== 'today') {
      task.due_date = task.due_date.setDate(task.due_date.getDate() + 1).toDate();
    }
    this.updateTask(task)
  }
  setColor(task) {
    this.currentDate = new Date()
    let dueDate = new Date(task.due_date)
    if (moment(dueDate).startOf('day') < moment(this.currentDate).startOf('day')) {
      return 'red';
    }
  }

  deleteConfirmation(projectData) {
    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'Are you sure want to delete this Task List?'
      }
    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.delete(projectData);
        }
      });
  }

  hideConfirmationTask(task) {
    if (this.preference.confirm_delete) {
      this.deleteTaskConfirmation(task);
    }
    if (!this.preference.confirm_delete) {
      this.deleteTask(task);
    }
  }
  hideConfirmationProject(project) {
    if (this.preference.confirm_delete) {
      this.deleteConfirmation(project);
    }
    if (!this.preference.confirm_delete) {
      this.delete(project);
    }
  }

  deleteTaskConfirmation(task) {
    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'Are you sure want to delete this Task?'
      }
    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.deleteTask(task);
        }
      });
  }

  taskListSort(priority) {
    let tasks = this.project.tasks
    this.sortedData = []
    this.setPriority = priority
    if (this.projects && this.projects.length) {
      tasks.forEach(task => {
        if (task.priority == this.setPriority) {
          this.sortedData.push(task)
        }
      })
    }
  }


  sortData(sort: string) {
    this.sortedData
    const data = this.project.tasks.slice();
    if (!sort) {
      this.sortedData = data;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = true;
      switch (sort) {
        case 'title': return compare(b.title, a.title, isAsc);
        case 'starred': return compare(a.starred, b.starred, isAsc);
        case 'my_day': return compare(+a.my_day, +b.my_day, isAsc);
        case 'HIGH': return compare(b.priority, a.priority, isAsc);
        case 'MEDIUM': return compare(a.priority, b.priority, isAsc);
        case 'LOW': return compare(b.priority, a.priority, isAsc);
        case 'due_date': return compare(+a.due_date, +b.due_date, isAsc);
        case 'is_completed': return compare(a.is_completed, b.is_completed, isAsc);
        case 'creation': return compare(a.creation, b.creation, isAsc);
        default: return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? -1 : 1);
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo-list/todo-list.component.ts